/**
 * Samples API Endpoints
 * Centralized endpoint definitions for sample operations.
 */
export const SAMPLES_ENDPOINTS = {
  /**
   * Get sample results by sample ID/barcode
   * @method GET
   * @endpoint /samples/{sampleId}
   * @param {string} sampleId - Sample barcode/ID (case-insensitive)
   */
  SAMPLE_RESULTS: (sampleId: string) => `/samples/${encodeURIComponent(sampleId)}`,
} as const;
